import { render, staticRenderFns } from "./ShowMenuElement.vue?vue&type=template&id=7cd774b5&"
import script from "./ShowMenuElement.vue?vue&type=script&lang=js&"
export * from "./ShowMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports